import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'ordersPicking';
export const ordersPickingActions = makeActions(MODEL_NAME, 'id', 'orders');

export const getAllOrdersPicking = ordersPickingActions.getAll;
export const editOrdersPicking = ordersPickingActions.edit;
export const createOrdersPicking = ordersPickingActions.create;
export const getByIdOrdersPicking = ordersPickingActions.getDataById;
